import type { ChatError } from './protocol'
import styles from './CodexChatRail.module.scss'

// One notice per failure state. The copy comes from the error code, so a
// busy runner, a conversation bound elsewhere, an unavailable agent and an
// application bug each read differently; Retry shows only where it helps.
export function ChatErrorNotice({
  error,
  onRetry,
}: {
  error: ChatError
  onRetry: () => void
}) {
  return (
    <div className={styles.errorBanner} role="alert" data-code={error.code}>
      <span>{error.message}</span>
      {error.retryable ? (
        <button type="button" className={styles.errorAction} onClick={onRetry}>
          Riprova
        </button>
      ) : null}
    </div>
  )
}
